// ============================================================
// DESIGN TOKENS — Industrial Utility Theme
// ============================================================
export const T = {
  bg0: "#0F0F0F",
  bg1: "#1A1A1A",
  bg2: "#242424",
  bg3: "#2E2E2E",
  orange: "#FF6B1A",
  orangeDim: "#C44E0E",
  green: "#22C55E",
  blue: "#3B9EFF",
  text: "#F0F0F0",
  textDim: "#888",
  textMute: "#555",
  border: "#333",
  danger: "#EF4444",
  enBubble: "#1D4ED8",
  esBubble: "#15803D",
  tlBubble: "#B45309",  // Tagalog — amber
  cebBubble: "#9333EA", // Cebuano — purple
  receivedBubble: "#4A2080",
};

// Supported languages — single source of truth
export const LANGUAGES = {
  en:  { label: "English",  badge: "EN",  color: T.enBubble },
  es:  { label: "Español",  badge: "ES",  color: T.esBubble },
  tl:  { label: "Tagalog",  badge: "TL",  color: T.tlBubble },
  ceb: { label: "Cebuano",  badge: "CEB", color: T.cebBubble },
};

export const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;900&family=Barlow+Condensed:wght@600;700;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
  html, body, #root { height: 100%; overflow: hidden; }
  body { background: ${T.bg0}; color: ${T.text}; font-family: 'Barlow', sans-serif; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: ${T.bg1}; }
  ::-webkit-scrollbar-thumb { background: ${T.border}; border-radius: 2px; }
  input, textarea { font-family: 'Barlow', sans-serif; }
  button { font-family: 'Barlow', sans-serif; cursor: pointer; }
  @keyframes fadeUp { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
  @keyframes pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(255,107,26,0.5); } 50% { box-shadow: 0 0 0 20px rgba(255,107,26,0); } }
  @keyframes wave { 0%,100% { transform: scaleY(0.4); } 50% { transform: scaleY(1); } }
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes blink { 0%,100% { opacity:1; } 50% { opacity:0.3; } }
  .msg-bubble { -webkit-touch-callout: none; -webkit-user-select: none; user-select: none; touch-action: pan-y; }
`;

export const inputStyle = {
  padding: "14px 16px",
  background: T.bg2,
  border: `1.5px solid ${T.border}`,
  borderRadius: 8,
  color: T.text,
  fontSize: 15,
  outline: "none",
  width: "100%",
};
